import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {Http} from '@angular/http';
import {Router} from '@angular/router';

import {ApiEvsService} from '../../common/services/ApiEvs.service';

@Injectable()
export class ExportFileService extends ApiEvsService {

  constructor(http: Http, router: Router) {
    super(http, router);
  }

  callApiExport(url):Observable<any>{
    return this.get(url);
  }

}



// WEBPACK FOOTER //
// /app/src/app/shared/services/export-file.service.ts